import * as React from "react";

import { cn } from "@shared/lib/cn";

/*
 * Поле ввода системы Nocturne в оболочке shadcn.
 *
 * Из пришедшего от генератора убраны: кольцо фокуса (обводку даёт глобальный
 * `:focus-visible` в `base.css`, и кольцо легло бы поверх неё), тень, ветки
 * `dark:` и `aria-invalid` — ни того, ни другого в системе нет, — и `md:`,
 * потому что кегль поля здесь один на все ширины.
 *
 * Поля набраны точными величинами: 36 / 8 / 14 / 13.5px в шкалу не ложатся и
 * не ложились. Снимать их со шкалы — решение дизайна.
 *
 * В v2 однострочное поле — капсула: у него одна строка, и скругление в
 * половину высоты не отрезает ничего. Многострочное осталось карточкой —
 * см. `textarea.tsx`.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Поле v6: утоплено в стекло тенью внутрь, без рамки; в фокусе — кольцо акцента.
        "w-full min-w-0 h-[40px] px-[16px]",
        "rounded-[var(--radius-pill)] border-0 bg-[color:var(--ui-sunken)]",
        "shadow-[var(--ui-field-sunk)] transition-shadow duration-200",
        "text-[14px]/[1.4] text-foreground caret-primary",
        "outline-none placeholder:text-faint",
        "focus-visible:shadow-[var(--ui-field-focus)] focus-visible:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-55",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
